import React from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { t } from '@billes/translator-client'
import { Filters } from 'components/Icons'

export default connect(
  {
    onOpenFilterMenu: signal`media.onOpenFilterMenu`,
    hasActiveFilter: state`media.filter.active`
  },
  ({ onOpenFilterMenu, hasActiveFilter }) => (
    <div
      title={t('bms.media.titles.toggleFilterMenu')}
      onClick={e => onOpenFilterMenu()}
      style={{ height: 48 }}
    >
      <svg
        fill="rgb(0, 105, 180)"
        height="20"
        viewBox="0 0 24 24"
        width="15"
        visibility={hasActiveFilter ? 'visible' : 'hidden'}
        style={{
          position: 'absolute',
          right: 5,
          marginTop: 0,
          zIndex: 90
        }}
      >
        <circle cx="10" cy="10" r="10" />
      </svg>
      <Filters
        style={{
          cursor: 'pointer',
          height: 36,
          width: 36,
          fill: '#afafaf'
        }}
        viewBox={'-4 0 26 26'}
      />
    </div>
  )
)



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/Filter/filterIcon.js